/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  fetchScheduleCardDetail,
  cancelScheduleCall,
} from '../../../services/consultation';
import CancelConfirmModal from '../CancelConfirmModal';

import timeIcon from '../../../images/consultations/time-icon.svg';

export class VideoCallMessage extends Component {
  state = {
    sessionDetails: {},
    textMessage: '',
    callStatus: null,
    isCancelled: false,
    showCancelConfirmModal: false,
  };
  componentDidMount() {
    this.fetchScheduleCardDetail();
  }

  cancelCall = () => {
    const { authToken, cardDetails } = this.props;
    cancelScheduleCall(cardDetails.consultationId, authToken)
      .then((res) => {
        this.hideModal();
        this.fetchScheduleCardDetail();
      })
      .catch((err) => {
        console.error('Error in canceling video call', err);
      });
  };

  fetchScheduleCardDetail = () => {
    fetchScheduleCardDetail(
      this.props.cardDetails.scheduleId,
      this.props.authToken
    )
      .then((res) => {
        console.log(res);
        this.setState({
          isCancelled: res.isCancelled,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  hideModal = () => {
    this.setState({
      showCancelConfirmModal: false,
    });
  };

  render() {
    const { cardDetails } = this.props;
    console.log(cardDetails);
    let time = '';
    if (cardDetails.rescheduleTime) {
      time += moment(cardDetails.rescheduleTime).format(
        'hh:mm a, MMMM Do YYYY '
      );
    }
    const isCancelled = this.state.isCancelled;
    return (
      <div
        className="rounded-12 my-16px"
        style={{
          margin: '21px 20px 0px 20px',
          border: `1px solid ${isCancelled ? '#F25540' : '#E3E3E3'}`,
        }}
      >
        <div className="px-20px py-16px">
          <p
            className="mb-12px font-semibold text-body-l"
            style={isCancelled ? { color: '#F25540' } : { color: '#0F0B28' }}
          >
            {isCancelled ? 'Cancelled' : 'You have a call scheduled at:'}
          </p>
          <div className="flex flex-row items-center mb-12px">
            <img src={timeIcon} alt="" />
            <p
              className="ml-6px text-title-m font-semibold"
              style={{ color: '#3A2CA0' }}
            >
              {time}
            </p>
          </div>
        </div>
        {!isCancelled ? (
          <div className="flex flex-row items-center justify-center border-t border-txtsecondary-shades4 py-16px">
            <p
              className="font-semibold text-body-l"
              style={{ color: '#F25540' }}
              onClick={() => {
                this.setState({
                  showCancelConfirmModal: true,
                });
              }}
            >
              Cancel
            </p>
          </div>
        ) : (
          ''
        )}
        {this.state.showCancelConfirmModal && (
          <CancelConfirmModal
            callType="video"
            header={'Are you sure you want to cancel?'}
            message={
              'You will have to schedule another call to consult if you cancel'
            }
            hideModal={this.hideModal}
            submit={() => {
              this.cancelCall();
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(VideoCallMessage);
